import React from 'react';

const STATUS_CONFIG = {
    arrear: {
        class: 'bg-danger-subtle text-danger',
        icon: 'bi-exclamation-triangle',
        label: 'En mora'
    },
    active: {
        class: 'bg-success-subtle text-success',
        icon: 'bi-check-circle',
        label: 'Al día'
    },
    current: {
        class: 'bg-success-subtle text-success',
        icon: 'bi-check-circle',
        label: 'Al día'
    },
    payed: {
        class: 'bg-secondary-subtle text-secondary',
        icon: 'bi-check-all',
        label: 'Finalizado'
    },
    finished: {
        class: 'bg-secondary-subtle text-secondary',
        icon: 'bi-check-all',
        label: 'Finalizado'
    },
    cancelled: {
        class: 'bg-secondary-subtle text-secondary',
        icon: 'bi-x-circle',
        label: 'Anulado'
    },
    pending: {
        class: 'bg-warning-subtle text-warning',
        icon: 'bi-clock',
        label: 'Pendiente'
    }
};

function LoanStatusBadge({ status }) {
    const config = STATUS_CONFIG[status] || STATUS_CONFIG.current;

    return (
        <span className={`badge ${config.class} d-inline-flex align-items-center gap-1`}>
            <i className={`bi ${config.icon}`}></i>
            {config.label}
        </span>
    );
}

export default LoanStatusBadge; 